import { errorBoundaryActionTypes } from '@/components/errorBoundary/Constants';

import type { ErrorBoundaryActions } from '@/components/errorBoundary/Actions';

export interface ErrorBoundaryState {
	error: string | Error;
}

const initialState: ErrorBoundaryState = {
	error: '',
};

export default function errorBoundaryReducer(
	state = initialState,
	action: ErrorBoundaryActions,
): ErrorBoundaryState {
	const { type, payload } = action;
	const { error } = payload || {};

	switch (type) {
		case errorBoundaryActionTypes.SET_ERROR:
			return {
				...state,
				error,
			};

		default:
			return state;
	}
}
